<sd-icon type="loader"></sd-icon>
